import React from 'react'
import { Box, SkeletonText } from '@creditas-ui/react'

export const DocumentsRequiredSkeleton = () => {
  return (
    <Box data-testid="loading-skeleton" paddingTop="10px">
      <Box>
        <SkeletonText
          color="light"
          lines={1}
          variant="body"
          margin="0 15px 8px 0"
          widthLastChildren="60%"
        />
        <SkeletonText
          color="light"
          lines={1}
          variant="body"
          margin="0 15px 20px 0"
          widthLastChildren="100%"
        />
      </Box>
      <Box>
        <SkeletonText
          color="light"
          lines={1}
          variant="body"
          margin="0 12px 8px 0"
          widthLastChildren="60%"
        />
        <SkeletonText
          color="light"
          lines={1}
          variant="body"
          margin="0 12px 20px 0"
          widthLastChildren="100%"
        />
      </Box>
      <Box>
        <SkeletonText
          color="light"
          lines={1}
          variant="body"
          margin="0 15px 8px 0"
          widthLastChildren="60%"
        />
        <SkeletonText
          color="light"
          lines={1}
          variant="body"
          margin="0 15px 20px 0"
          widthLastChildren="100%"
        />
      </Box>
    </Box>
  )
}
